<template>
  <div class="store__item" @click="$emit('click-store')">
    <img class="store__item__img" :src="store.pic" alt="" />
    <div class="store__item__details">
      <div class="name">{{ store.name }}</div>
      <div class="msg">{{ store.tagline }}</div>
      <!-- <div class="store">官方自营旗舰店</div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    store: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.store__item {
  display: flex;
  width: 296px;
  height: 96px;
  padding: 16px;
  background: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 16px;
  & + .store__item {
    margin-left: 16px;
  }
  &:nth-child(4n + 1) {
    margin-left: 0;
  }
  &:nth-child(n + 4) {
    margin-bottom: 0;
  }
  &__img {
    width: 64px;
    height: 64px;
    margin-right: 16px;
  }
  &__details {
    .name {
      height: 24px;
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 4px;
      color: #262626;
      line-height: 1.5;
    }
    .msg,
    .store {
      height: 18px;
      font-size: 12px;
      font-weight: 400;
      color: #595959;
      line-height: 1.5;
    }
  }
}
</style>
